import { Stock, StockData } from "@src/app/types/Stocks";
import { http } from "@src/app/util/httpClient";
import { parseString } from "xml2js";

const STI_TOP_ACTIVE =
  import.meta.env.VITE_SGX_STI_TOP_ACTIVE ||
  "https://sph.shareinvestor.com/price/sti_top_active.xml";

export const fetchRequests = {
  fetchStocksData: async () => {
    if (!STI_TOP_ACTIVE) return;

    const request = await http.get(STI_TOP_ACTIVE);
    const data = request.data as string;
    let parseData = {};

    parseString(data, (_, results) => {
      const dataObject = {
        channel: results.securities.$.channel,
        lastUpdatedTime: results.securities.$.last_updated_time,
        stocks: [],
      } as StockData;

      Object.keys(results.securities.counter).forEach((key: string) => {
        dataObject.stocks.push(results.securities.counter[key].$ as Stock);
      });

      parseData = dataObject;
    });

    return parseData as StockData;
  },
};
